
export const environment = {
    production: true,
    env: 'pre prod',
    baseUrl:'https://aws-navendor-global-api-pp.clickitapp.io',
  firebase : {
    apiKey: 'AIzaSyDQ1yTHYJ-pBTMl5l1Rt4C9Oeh37shZEms',
    authDomain: 'clickit-lafarge-dev.firebaseapp.com',
    databaseURL: 'undefined',
    projectId: 'clickit-lafarge-dev',
    storageBucket: 'clickit-lafarge-dev.firebasestorage.app',
    messagingSenderId: '1035713439082',
    appId: '1:1035713439082:web:0f7f639e851fcd3e57b113',
    measurementId: 'G-D4WV737Y4H',
    vapidKey: 'BPLX35OOwgX5SF-11QsC_ZZy9IeDwM37p5oN948e3U2q500W9NqLLmqiJ_XlAYZwkSXfcUE0230_Dw8e8mdQH5k'
  },
  RECAPTCHA_SITE_KEY: '6LdxIBgrAAAAAKbrRF0-oxbDktQrodw2ofRstKRp',
  HEROKU_RELEASE_VERSION: '2.34.1'
};